import { createContext, useContext, useState } from "react";

const StateContext = createContext({
  data: {},
  setData: () => {},
  projectData: {},
  setprojectData: () => {},
  selectedItems: {},
  setSelectedItems: () => {},
});

export const ContextProvider = ({ children }) => {
  const initialData = {
    content: [],
    root: {},
    zones: {},
  };

  const [data, setData] = useState(initialData);
  const [projectData, setprojectData] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);

  return (
    <StateContext.Provider
      value={{
        data,
        setData,
        projectData,
        setprojectData,
        selectedItems,
        setSelectedItems,
      }}
    >
      {children}
    </StateContext.Provider>
  );
};

export const useStateContext = () => useContext(StateContext);
